module.exports = __webpack_public_path__ + "static/HazelValue1.cc8b9c50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/HazelValue1.jpg
// module id = 395
// module chunks = 246227742792961